import { ibhApiService } from '@hub/bearing-hub/common/api-service';
import type {
  IbhBearingPartsLightParams,
  IbhPartsRequestDto,
  IbhPartsResponseDto,
} from '@igus/iglidur-bearing-hub-api/src/data-contracts';
import * as Sentry from '@sentry/nextjs';

export const fetchParts = async (
  query: IbhBearingPartsLightParams,
  data: IbhPartsRequestDto
): Promise<IbhPartsResponseDto[]> => {
  try {
    // The API client is shared across concurrent Next.js requests.
    const cancelToken = typeof window !== 'undefined' ? 'bearingPartsLight' : undefined;
    if (cancelToken) {
      ibhApiService.abortRequest(cancelToken);
    }
    const response = await ibhApiService.bearingPartsLight(query, { ...data }, { cancelToken });
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      contexts: {
        request: {
          query,
          data: { ...data },
        },
      },
      tags: {
        api_call: 'bearingPartsLight',
      },
      level: 'error',
    });
    throw new Error(`Cannot fetch parts for given data: ${JSON.stringify(data)}`);
  }
};
